import Clients from './logics/clients';
import Products from './logics/product';
import Proposal from './logics/proposal';
import Proposals from './logics/proposals';
import Operations from './logics/operations';
import CustomQuotes from './logics/custom-quotes';
import CreateOperation from './logics/create-operation';

export default [Products].concat(Operations, CreateOperation, Proposals, Clients, Proposal, CustomQuotes);
